import { ref } from '@nuxtjs/composition-api';

// IM: İdeal Media
export const initializeIM = (adTags) => {
  const isIMLoaded = ref(false);
  if (!isIMLoaded.value) {
    adTags.script.push(
      {
        hid: 'im',
        src: 'https://jsc.idealmedia.io/site/1031473.js',
        async: true,
        callback: () => {
          isIMLoaded.value = true;
        },
      },
      {
        hid: 'imInit',
        innerHTML: `
          (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
        `,
      }
    );
  }
};
